<!--生产领料退库单 生产领料退库单详情-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-col>
          <el-table :data="tableData" border stripe style="margin-top: 20px" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_BATCH" label="产品批次"></el-table-column>
            <el-table-column prop="PRICE" label="价格"></el-table-column>
            <!-- <el-table-column prop="BEFORE_TAX_PRICE" label="不含税价格"></el-table-column>
            <el-table-column prop="TAX_RATE" label="税率"></el-table-column> -->
            <el-table-column prop="PRODUCT_COUNT" label="领料数量"></el-table-column>
        <el-table-column prop="RETURN_COUNT" label="已退数量"></el-table-column>
            <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <el-tag v-show="scope.row.STATUS == 1" type="warning">{{ showStatus[scope.row.STATUS - 1] }}</el-tag>
                <el-tag v-show="scope.row.STATUS == 2">{{ showStatus[scope.row.STATUS - 1] }}</el-tag>
                <el-tag v-show="scope.row.STATUS == 3" type="success">{{ showStatus[scope.row.STATUS - 1] }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="finishPro(scope.row)" type="text" v-if="scope.row.STATUS == 1">生产完成</el-button>
                <el-button @click="openResult(scope.row)" type="text" v-else>查看生产</el-button>
                <!-- <el-button @click="returnWare(scope.row)" type="text">退库</el-button> -->
              </template>
            </el-table-column>
            <el-table-column type="selection" v-if="showReturn" :selectable="(row)=>row.STATUS==1"></el-table-column>
          </el-table>
        </el-col>
      </el-col>
      <el-col>
        <el-button @click="openReturn" style="float: right;margin: 10PX 0 0 10px" v-if="showReturn">批量退库</el-button>
        <el-button @click="toPrintTable" style="float: right;margin-top: 10px">打印</el-button>
      </el-col>
    </el-row>
    <!-- 生产完成弹框 -->
    <el-dialog title="选择商品" :visible.sync="editFormVisible" width="30%" center>
      <el-form :model="editForm" ref="editForm" size="small">
        <el-form-item label="生产别名：" :label-width="formLabelWidth">
          <el-select filterable v-model="editForm.NAME" clearable style="width:90%">
            <el-option v-for="item in proResult" :key="item.ID" :label="item.ALIAS_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button @click="submitFinish('secondForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 生产后产品 -->
    <el-dialog title="生产商品" :visible.sync="afterFormVisible" width="800px" center>
      <el-table :data="productLists" border stripe>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="名称" prop="NAME"></el-table-column>
        <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRODUCT_COUNT"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="市场价格">
          <template slot-scope="scope">
            <el-input v-model="scope.row.MARKET_PRICE"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRODUCT_COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="afterFormVisible = false">取 消</el-button>
        <el-button @click="submitEnter('secondForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="退库" center :visible.sync="returnDialogVisible" width="1300px">
      <el-table :data="returnList">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_BATCH" label="产品批次"></el-table-column>
        <el-table-column prop="PRICE" label="价格"></el-table-column>
        <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="领料数量"></el-table-column>
        <el-table-column prop="RETURN_COUNT" label="已退数量"></el-table-column>
        <el-table-column prop="NEW_RETURN_COUNT" label="退库数量" min-width="130">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.NEW_RETURN_COUNT"
              :placeholder="`最多可退${scope.row.PRODUCT_COUNT-scope.row.RETURN_COUNT}${scope.row.TYPE_UNIT}`" clearable
              @change="checkNewReturnCount(scope.row)">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDocDetailFun, finishFun, submitFinish, enterFun, returnWareFun,
} from 'api/proDepartment';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      departmentList: [],
      pickerOptions: [],
      titleData: [],
      editFormVisible: false,
      proResult: [],
      editForm: {},
      formLabelWidth: '100px',
      productLists: [],
      afterFormVisible: false,
      showStatus: ['未生产', '已生产', '已入库'],
      returnFormVisible: false,
      returnForm: {},
      showReturn: true,
      returnList: [],
      returnDialogVisible: false,
    };
  },
  created() {
    this.queryData();
    this.titleData = JSON.parse(sessionStorage.getItem('titleData'));
    console.log(this.titleData);
  },
  methods: {
    queryData() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderID')),
      };
      getDocDetailFun(params).then((res) => {
        this.tableData = res.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }));
        this.showReturn = Boolean(this.tableData.find((item) => item.STATUS == 1));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openDetail() {
      this.$router.push({ path: '/pickingDocDetail/detail' });
    },
    finishPro(row) {
      this.editFormVisible = true;
      this.editForm = row;
      const params = {
        CP_CODE: row.PRODUCT_CODE,
      };
      finishFun(params).then((result) => {
        this.proResult = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitFinish() {
      const params = {
        DETAIL_ID: this.editForm.ORDER_DETAIL_ID,
        PPL_ID: this.editForm.NAME,
      };
      submitFinish(params).then((result) => {
        this.afterFormVisible = true;
        this.productLists = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitEnter() {
      let submitArr = [];
      submitArr = this.productLists.map((item) => ({
        OP_CODE: item.OP_CODE,
        OP_COUNT: item.PRODUCT_COUNT,
        MARKET_PRICE: item.MARKET_PRICE || 0,
        PRODUCT_COMMENT: item.PRODUCT_COMMENT || '',
        OP_FEE: item.PRODUCT_FEE,
      }));
      const params = {
        INNER_DETAIL_ID: this.editForm.ORDER_DETAIL_ID,
        ORDER_ID: Number(sessionStorage.getItem('orderID')),
        PRODUCT_ARRAY: submitArr,
      };
      enterFun(params).then((result) => {
        this.afterFormVisible = false;
        this.editFormVisible = false;
        this.$message.show({ text: '生产完成', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openResult(row) {
      this.$router.push({ name: 'proPickingResult' });
      sessionStorage.setItem('innerId', row.ORDER_DETAIL_ID);
      sessionStorage.setItem('pickStatus', row.STATUS);
    },
    returnWare(row) {
      this.returnFormVisible = true;
      this.returnForm = row;
    },
    submitReturn() {
      const params = {
        RETURN_DATA_DETAIL: this.returnList.map((item) => ({
          ORDER_DETAIL_ID: item.ORDER_DETAIL_ID,
          RETURN_COUNT: Number(item.NEW_RETURN_COUNT),
        })),
      };
      returnWareFun(params).then((result) => {
        this.returnDialogVisible = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += '<div class="title">生产领料单</div>';
      html += `<div class="head"><div class="code">领料人：${this.titleData.REQUISITIONER}</div><div>领料部门：生产部</div></div>`;
      html += `<div class="head"><div class="code">领料日期：${this.titleData.SEND_DAY}</div><div>领料总金额：${this.titleData.TOTAL_FEE}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 40px">序号</th><th>产品编码</th> <th>产品</th> <th  style="width: 40px">单位</th><th >单价</th> <th style="width: 70px">领料数量</th> <th  style="width: 70px">领料金额</th> <th>备注</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_CODE}</td> <td>${item.PRODUCT_NAME}</td><td>${item.TYPE_UNIT}</td> <td>${item.PRICE}</td>
                        <td>${item.PRODUCT_COUNT}</td> <td>${Math.round(item.PRODUCT_COUNT * item.PRICE * 100) / 100} </td> <td>${item.PRODUCT_COMMENT}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '<div style="margin-top: 20px; display: flex; flex-direction: row;"><div>领料人：</div><div style="margin-left: 200px">主管：</div></div>';
      html += '</div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    handleSelectionChange(val) {
      this.returnList = val;
    },
    openReturn() {
      if (this.returnList.length == 0) {
        this.$message.show({ text: '请选择要退库的产品', type: 'warning' });
        return false;
      }
      this.returnDialogVisible = true;
    },
    close() {
      this.returnDialogVisible = false;
    },
    checkNewReturnCount(row) {
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      const reg2 = /^[+]{0,1}[1-9](\d*)$/;
      if (this.$util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!reg1.test(row.NEW_RETURN_COUNT)) {
          this.$message.show({ text: '请输入正数退库数量', type: 'warning' });
          return false;
        }
      } else {
        if (!reg2.test(row.NEW_RETURN_COUNT)) {
          this.$message.show({ text: '请输入正整数退库数量', type: 'warning' });
          return false;
        }
      }
    },
  },
};
</script>

<style scoped>
.pagination_box {
  float: right;
}

.spec-drawer /deep/ .el-drawer__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}
</style>



// WEBPACK FOOTER //
// src/components/productionProcessing/proPickingDocDetail.vue